export default "__VITE_ASSET__9YVT9RK6__"